module.exports = __webpack_public_path__ + "static/media/close-outline.4710dcc6.svg";